import classNames from 'classnames'
import PlusIcon from '../icons/PlusIcon'
import LoadingSpinner from '../loading-spinner'

type PropTypes = {
  user?: {
    name: string
    profile_picture_url?: string
  },
  onClick?: () => void,
  isLoading?: boolean
  profilePictureOverride?: string
  size?: 'small' | 'medium' | 'large'
}

const UserAvatar = ({ user, onClick, isLoading = false, profilePictureOverride, size = 'medium' }: PropTypes) => {
  return (
    <div>
      <div
        className={classNames(
          'relative aspect-square bg-primary-500 rounded-full flex items-center justify-center capitalize text-gray-900 group',
          {
            'h-20 w-20 text-[16px]': size === 'large',
            'h-[35px] w-[35px] text-[16px]': size === 'medium',
            'h-[30px] w-[30px]': size === 'small',
          },
        )}
      >
        {
          (profilePictureOverride ?? user?.profile_picture_url)
            && (
              <img
                src={profilePictureOverride ?? user?.profile_picture_url}
                alt={user?.name}
                className="absolute inset-0 object-cover rounded-full h-full w-full"
              />
            )
        }
        {
          !(profilePictureOverride ?? user?.profile_picture_url)
            && (
              <p>{user?.name[0] ?? ''}</p>
            )
        }
        {
          onClick
            && (
              <button
                className={classNames('absolute rounded-full bg-black hover:opacity-70 w-full h-full flex items-center justify-center transition-all', { 'opacity-70': isLoading, 'opacity-0': !isLoading })}
                onClick={onClick}
                disabled={isLoading}
              >
                {
                  isLoading
                    ? <LoadingSpinner className="w-6 h-6 text-white" />
                    : <PlusIcon className="w-6 h-6 text-white" />
                }
              </button>
            )
        }
      </div>
    </div>
  )
}

export default UserAvatar
